import React, { useEffect, useState } from "react";
import {
  Modal,
  Form,
  Input,
  Button,
  Row,
  Col,
  Typography,
  Tag,
  Space,
  Divider,
  message,
  Upload,
} from "antd";
import Dragger from "antd/es/upload/Dragger";
import {
  CalendarOutlined,
  FilePdfOutlined,
  EnvironmentOutlined,
  CarOutlined,
  ClockCircleOutlined,
  AimOutlined,
  CheckCircleOutlined,
  FileSearchOutlined,
  UserOutlined,
  PushpinOutlined,
  HomeOutlined,
  CompassOutlined,
  InboxOutlined,
  DeleteOutlined,
  DollarOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import ThaiDatePicker from "../../../../hook/ThaiDatePicker";
import Compressor from "compressorjs";

const { Text } = Typography;

// ✅ จำนวนวันนัดขายทอดตลาด
const SALE_ROUNDS = 6;
const ROUND_LIST = Array.from({ length: SALE_ROUNDS }, (_, i) => i + 1);

const SetSalesChedulemodal = ({
  open,
  onClose,
  selectedGroups = [],
  onSuccess,
}) => {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [allImg, setAllImg] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [loading, setLoading] = useState(false);

  // ✅ reset ฟอร์มทุกครั้งที่เปิด
  useEffect(() => {
    if (open) form.resetFields();
  }, [open, form]);

  // ✅ สรุปแปลงที่เลือก
  const allLands = selectedGroups.flatMap((g) => g.lands || []);
  const totalLands = allLands.length;
  const contnoList = [...new Set(selectedGroups.map((g) => g.contno))];

  // ✅ validator: นัดถัดไปต้องเป็นวันหลังนัดก่อนหน้า และห้ามเว้นว่างข้ามนัด
  const makeRoundValidator = (round) => () => ({
    validator(_, value) {
      if (round === 1) {
        return value
          ? Promise.resolve()
          : Promise.reject(new Error("กรุณาเลือกวันนัดที่ 1"));
      }

      const prev = form.getFieldValue(`saleDate${round - 1}`);

      if (value && !prev) {
        return Promise.reject(
          new Error(`กรุณาเลือกวันนัดที่ ${round - 1} ก่อน`),
        );
      }

      if (value && prev && !dayjs(value).isAfter(dayjs(prev), "day")) {
        return Promise.reject(new Error(`ต้องเป็นวันหลังนัดที่ ${round - 1}`));
      }

      return Promise.resolve();
    },
  });

  const handleFinish = async (values) => {
    // ✅ ขั้นนี้ลงเฉพาะ "วันนัด" — ผลการขายไปบันทึกทีหลังตอนสถานะ "มีวันนัดขายแล้ว"
    const saleSchedule = ROUND_LIST.map((round) => ({
      round,
      date: values[`saleDate${round}`]
        ? dayjs(values[`saleDate${round}`]).format("YYYY-MM-DD")
        : null,
    })).filter((s) => s.date);

    const payload = {
      lotNo: values.lotNo,
      saleSchedule,
      groups: selectedGroups.map((g) => ({
        contno: g.contno,
        customerId: g.customerId,
        province: g.province,
        landIds: (g.lands || []).map((l) => l.landId),
      })),
      landIds: allLands.map((l) => l.landId),
    };

    try {
      setSubmitting(true);

      // TODO: เรียก API จริงตรงนี้
      // await axios.post(POST_SET_SALE_SCHEDULE, payload, {
      //   headers: HEADERS_EXPORT_BEN,
      // });

      console.log("📤 sale schedule payload:", payload);
      message.success("บันทึกวันนัดขายสำเร็จ");
      onSuccess?.(payload);
      onClose(false);
    } catch (error) {
      console.error("❌ Error:", error);
      message.error(error.response?.data?.message || "บันทึกไม่สำเร็จ");
    } finally {
      setSubmitting(false);
    }
  };

  const compressImage = async (file, types, index) => {
    return new Promise((resolve) => {
      let quality;
      if (file.size >= 2500000) quality = 0.1;
      else if (file.size >= 2000000) quality = 0.15;
      else if (file.size >= 1500000) quality = 0.2;
      else if (file.size >= 1000000) quality = 0.3;
      else quality = 0.5;

      new Compressor(file, {
        quality: quality,
        success: (result) => {
          const fileOptions = {
            type: result.type,
            lastModified: Date.now(),
          };
          const compressedFileAsFile = new File(
            [result],
            file.name,
            fileOptions,
          );

          const image = {
            imageCompressedFile: compressedFileAsFile,
            type: types,
            originalIndex: index,
          };

          setAllImg((prev) => [...prev, image]);
          setLoading(false);
          resolve(true);
        },
        error: (err) => {
          console.error("Compressor error:", err);
          message.error(`ไม่สามารถบีบอัดไฟล์ "${file.name}" ได้`);
          setLoading(false);
          resolve(true);
        },
      });
    });
  };

  // ลบรูป (รับ array)
  // const handleDeleteIMG = async (images) => {
  //   if (!images || images.length === 0) return;

  //   setLoading(true);
  //   try {
  //     const res = await axios.delete(POST_DELETE_IMAGE_NEW, {
  //       data: images,
  //       headers: HEADERS_UPIMAGE,
  //     });

  //     if (res.status === 200) {
  //       const selectedPaths = new Set(images.map((img) => img.path));
  //       message.success("ลบรูปสำเร็จ");
  //     }
  //   } catch (err) {
  //     message.error("เกิดข้อผิดพลาด ลบรูปไม่สำเร็จ");
  //     console.error("err", err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // ลบรูปเดียว - ส่งเป็น array
  // const handleDeleteSingleImage = async (image) => {
  //   await handleDeleteIMG([image]);
  // };

  // Preview รูป
  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handlePreview = async (file) => {
    if (file.type === "application/pdf" || file.name.endsWith(".pdf")) {
      let pdfUrl = file.url;
      if (!pdfUrl && file.originFileObj) {
        pdfUrl = URL.createObjectURL(file.originFileObj);
      }
      window.open(pdfUrl, "_blank");
      return;
    }

    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  // Handle change file list
  const handleChangeIMG = ({ fileList: newFileList, file }) => {
    const updatedFileList = newFileList.map((f) => f);

    setFileList(updatedFileList);

    if (file.status === "removed") {
      setAllImg((prevAllImg) => {
        return prevAllImg.filter((img) => img.originalIndex !== file.uid);
      });
    }

    if (
      file.status === "done" ||
      file.status === "removed" ||
      file.status === "error"
    ) {
      setLoading(false);
    }
  };

  // Before upload
  const beforeUpts = async (file, ty) => {
    const isPdf =
      file.type === "application/pdf" ||
      file.name.toLowerCase().endsWith(".pdf");

    if (isPdf) {
      const image = {
        imageCompressedFile: file,
        type: ty,
        originalIndex: file.uid,
      };
      setAllImg((prev) => [...prev, image]);
      return false;
    }

    if (file.size > 5000000) {
      message.warning(`ไฟล์ "${file.name}" เกิน 5MB`);
      return Upload.LIST_IGNORE;
    }

    try {
      setLoading(true);
      await compressImage(file, ty, file.uid);
      return false;
    } catch (error) {
      console.error("File processing error:", error);
      message.error("File processing failed.");
      return Upload.LIST_IGNORE;
    }
  };

  // Upload Props
  const uploadProps = {
    name: "file",
    multiple: true,
    accept: "image/*,.pdf",
    listType: "picture",
    fileList: fileList,
    onPreview: handlePreview,
    onChange: handleChangeIMG,
    beforeUpload: (file) => beforeUpts(file, 3),
    iconRender: (file) => {
      if (file.type === "application/pdf" || file.name.endsWith(".pdf")) {
        return (
          <FilePdfOutlined style={{ fontSize: "48px", color: "#ff4d4f" }} />
        );
      }
      return null;
    },
  };

  return (
    <Modal
      title="กำหนดวันนัดขายทอดตลาด"
      open={open}
      onCancel={() => onClose(false)}
      width={720}
      footer={null}
      destroyOnHidden
    >
      {/* สรุปแปลงที่เลือก */}
      <div style={{ marginBottom: 16 }}>
        <Space wrap size={8}>
          <Tag color="purple">{selectedGroups.length} กลุ่มทรัพย์</Tag>
          <Tag color="blue">{totalLands} แปลง</Tag>
          {contnoList.map((c) => (
            <Tag key={c}>{c}</Tag>
          ))}
        </Space>
      </div>

      <Form form={form} layout="vertical" onFinish={handleFinish}>
        <Form.Item
          label="เลข Lot"
          name="lotNo"
          rules={[{ required: true, message: "กรุณาระบุเลข Lot" }]}
        >
          <Input placeholder="เช่น A-01" allowClear style={{ maxWidth: 240 }} />
        </Form.Item>

        <Divider orientation="left" style={{ margin: "8px 0 16px" }}>
          <Space>
            <CalendarOutlined />
            <Text strong>วันนัดขาย ({SALE_ROUNDS} นัด)</Text>
          </Space>
        </Divider>

        <Row gutter={[16, 0]}>
          {ROUND_LIST.map((round) => (
            <Col xs={24} sm={12} key={round}>
              <Form.Item
                label={`นัดที่ ${round}`}
                name={`saleDate${round}`}
                dependencies={round > 1 ? [`saleDate${round - 1}`] : []}
                rules={[makeRoundValidator(round)]}
              >
                <ThaiDatePicker
                  style={{ width: "100%" }}
                  placeholder={`เลือกวันนัดที่ ${round}`}
                />
              </Form.Item>
            </Col>
          ))}
        </Row>
        <Form.Item name="img" label="เอกสารประกาศขาย">
          <Dragger {...uploadProps} style={{ width: "100%", minHeight: 200 }}>
            <p className="ant-upload-drag-icon">
              <InboxOutlined style={{ color: "blue", fontSize: 48 }} />
            </p>
            <p className="ant-upload-text" style={{ fontSize: 16 }}>
              คลิกหรือลากไฟล์มาวางที่นี่
            </p>
            <p className="ant-upload-hint" style={{ fontSize: 12 }}>
              รองรับการอัปโหลดหลายไฟล์พร้อมกัน
            </p>
          </Dragger>
        </Form.Item>

        <div style={{ textAlign: "center", marginTop: 8 }}>
          <Button
            onClick={() => onClose(false)}
            style={{ marginRight: 16 }}
            size="large"
          >
            ปิด
          </Button>
          <Button
            type="primary"
            size="large"
            htmlType="submit"
            loading={submitting}
          >
            บันทึกวันนัดขาย
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default SetSalesChedulemodal;
